import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/sections/HeroSection';
import NewsSection from '../components/sections/NewsSection';
import MentorSection from '../components/sections/MentorSection';
import FAQSection from '../components/sections/FAQSection';
import SecretsSection from '../components/sections/SecretsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import Footer from '../components/sections/Footer';
import MetaTags from '../components/common/MetaTags';
import { sendToN8nWebhook, prepareFormData, isWebhookConfigured } from '../config/webhooks';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    countryCode: '+55',
    whatsapp: ''
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Validações básicas
    if (!formData.nome.trim()) {
      alert('Por favor, preencha seu nome.');
      return;
    }

    if (!formData.email.trim() || !formData.email.includes('@')) {
      alert('Por favor, preencha um email válido.');
      return;
    }

    if (!formData.whatsapp.trim()) {
      alert('Por favor, preencha seu WhatsApp.');
      return;
    }

    // Preparar dados para envio usando a função utilitária
    const submissionData = prepareFormData(formData, {
      ip_address: '', // Será preenchido pelo n8n se necessário
      form_version: '1.0'
    });

    // Log dos dados capturados
    console.log('📋 Dados capturados:', submissionData);

    // Verificar se o webhook está configurado
    if (!isWebhookConfigured()) {
      console.warn('⚠️ Webhook do n8n não configurado. Dados salvos localmente.');
      // Salvar no localStorage como fallback
      localStorage.setItem('lead_' + Date.now(), JSON.stringify(submissionData));
    }

    // Envio para webhook do n8n
    try {
      await sendToN8nWebhook(submissionData);

      // Sucesso: limpar formulário e redirecionar com o nome da pessoa
      const nomeParaObrigado = formData.nome;
      setFormData({ nome: '', email: '', countryCode: '+55', whatsapp: '' });
      navigate('/obrigado', { state: { nome: nomeParaObrigado } });

    } catch (error) {
      console.error('❌ Erro ao enviar para o webhook do n8n:', error);

      // Fallback: salvar localmente e ainda redirecionar para não prejudicar UX
      localStorage.setItem('lead_fallback_' + Date.now(), JSON.stringify(submissionData));

      // Redirecionar para a página de obrigado com o nome da pessoa
      navigate('/obrigado', { state: { nome: formData.nome } });

      // Limpar formulário mesmo em caso de erro
      setFormData({ nome: '', email: '', countryCode: '+55', whatsapp: '' });
    }
  };

  // Função para formatar telefone brasileiro
  const formatPhoneBR = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '');

    // Aplica a máscara baseada no tamanho
    if (numbers.length <= 2) {
      return `(${numbers}`;
    } else if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    } else {
      // Limita a 11 dígitos
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  const handleInputChange = (field, value) => {
    let processedValue = value;

    // Formatar telefone apenas para números brasileiros
    if (field === 'whatsapp' && formData.countryCode === '+55') {
      processedValue = formatPhoneBR(value);
    }

    setFormData(prev => ({
      ...prev,
      [field]: processedValue
    }));
  };

  return (
    <div className="landing-page">
      <MetaTags
        title="Sala Secreta - Do Zero ao Lucro: O único método para Viver de Trade"
        description="Aprenda a única forma REAL de ganhar dinheiro no trade começando do zero - Se inscreva na Sala Secreta, de 30/06 a 02/07 às 20h no Zoom (sem gravação). Se inscreva!"
        keywords="trade, trading, forex, bolsa de valores, day trade, viver de trade, educação financeira, investimentos, SBX Trade, Eduardo SBX"
        image="https://sbxtreinamentos.com.br/webinario/images/og-image.jpg"
        url="https://webinario.sbxtreinamentos.com.br/"
        type="website"
        author="Eduardo SBX"
        siteName="SBX Trade"
      />
      <main>
        <HeroSection
          formData={formData}
          onInputChange={handleInputChange}
          onSubmit={handleFormSubmit}
        />
        <NewsSection />
        <MentorSection />
        <FAQSection />
        <SecretsSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
